import { Button, Form, Input, InputNumber, notification } from 'antd';
import { UserApi } from '../../../shared/api';
import { useUserDataStore } from '../../../shared/store';
import { useState } from 'react';

type AddSellerBankInfoForm = {
  account: string;
  mfo: string;
  phone: string;
};
export const AddSellerBankInfo = () => {
  const [form] = Form.useForm<AddSellerBankInfoForm>();
  const [loading, setLoading] = useState(false);
  const setUser = useUserDataStore((s) => s.setUser);
  const [api, contextHolder] = notification.useNotification();
  const onSubmit = (values: AddSellerBankInfoForm) => {
    setLoading(true);
    const { account, mfo, phone } = values;
    UserApi.updateUserBankInfo({ bank: { account: account, mfo: mfo }, phone }).then((res) => {
      if (res?.success) {
        UserApi.getUserMe().then((res) => {
          localStorage.setItem('userData', JSON.stringify(res?.data));
          setUser(res?.data);
        });
      } else {
        api.error({
          key: 'unique_key',
          message: <div className='text-[16px] font-[400] text-[#14161F]'>{res?.message}</div>,
        });
      }
    });
    setLoading(false);
  };
  const selectedEDS = useUserDataStore((state) => state.selectedEDS);
  return (
    <div
      style={{
        backgroundColor: '#F9F8F4',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {contextHolder}
      <div className='p-5 w-[400px] bg-[#fff] rounded-[32px] flex flex-col gap-6 justify-center items-center'>
        <h1 className='text-[21px] font-[400] text-[#14161F]'>Vasit</h1>
        <div className='flex flex-col gap-2 bg-[#F7F5EF] rounded-[16px] p-4 w-full items-start'>
          <p className='text-[16px] font-[400] text-[#14161f99]'>Наименование получателя </p>
          <h6 className='text-[16px] font-[500] text-[#14161F]'>{selectedEDS?.O}</h6>
        </div>
        <Form
          onFinish={onSubmit}
          form={form}
          className='w-full'
          initialValues={{
            account: '',
            mfo: '',
            phone: '',
          }}
          layout='vertical'
        >
          <Form.Item name={'mfo'} className='w-full mb-4' label='Код банка'>
            <Input
              maxLength={5}
              className='w-full border !border-[#C6C6C8] !bg-[#74748014] !shadow-none !h-14'
              placeholder='введите код банка'
              size='large'
              inputMode='numeric'
              onChange={(e) => {
                e.target.value = e.target.value.replace(/\D/g, '');
                form.setFieldValue('mfo', e.target.value);
              }}
            />
          </Form.Item>
          <Form.Item name={'account'} className='mb-4' label='Счет'>
            <Input
              maxLength={20}
              className='w-full border !border-[#C6C6C8] !bg-[#74748014] !shadow-none !h-14'
              placeholder='введите номер счета'
              size='large'
              inputMode='numeric'
              onChange={(e) => {
                e.target.value = e.target.value.replace(/\D/g, '');
                form.setFieldValue('account', e.target.value);
              }}
            />
          </Form.Item>
          <Form.Item name={'phone'} label='Телефон номер'>
            <Input
              required
              style={{ width: '100%' }}
              className='w-full border !border-[#C6C6C8] !bg-[#74748014] !shadow-none !h-14'
              placeholder='+998'
              maxLength={13}
              minLength={13}
              size='large'
              onChange={(e) => {
                const onlyDigits = e.target.value.replace(/[^\d+]/g, '');
                if (!onlyDigits.startsWith('+998')) {
                  form.setFieldValue('phone', '+998');
                } else {
                  form.setFieldValue('phone', onlyDigits.slice(0, 13));
                }
              }}
            />
          </Form.Item>

          <Button
            size='large'
            className='w-full !bg-[#6155F5] h-14'
            block
            type='primary'
            htmlType='submit'
            loading={loading}
            disabled={loading}
          >
            Далее
          </Button>
        </Form>
      </div>
    </div>
  );
};
